import { motion } from "framer-motion";
import { Phone, MapPin, Clock } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { fadeInUp, staggerContainer } from "@/lib/constants";

const ContactSection = () => {
  return (
    <section id="contact" data-testid="contact-section" className="section-spacing bg-[#0F4C81]">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.span
              variants={fadeInUp}
              className="inline-block font-accent text-sm font-semibold tracking-widest uppercase text-white/70 mb-4"
            >
              Get In Touch
            </motion.span>
            <motion.h2
              variants={fadeInUp}
              className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-6"
            >
              Ready to Start Your Project?
            </motion.h2>
            <motion.p
              variants={fadeInUp}
              className="font-body text-lg leading-relaxed text-white/80 mb-8"
            >
              Contact us today for a free consultation and quote. We'll help you find the perfect glass solution for your space.
            </motion.p>
            <motion.div variants={fadeInUp} className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-body text-sm text-white/60">Call Us</div>
                  <a href="tel:910-457-4757" className="font-heading text-xl text-white hover:text-white/80 transition-colors">
                    910-457-4757
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-body text-sm text-white/60">Service Area</div>
                  <div className="font-heading text-xl text-white">Coastal North Carolina</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <Clock className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-body text-sm text-white/60">Hours</div>
                  <div className="font-heading text-xl text-white">Mon-Fri: 8AM - 5PM</div>
                </div>
              </div>
            </motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 md:p-12"
          >
            <h3 className="font-heading text-2xl font-medium text-[#1A202C] mb-6">Request a Quote</h3>
            <QuoteForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
